import React from 'react';
import { useCart } from '../context/CartContext';
import { jsPDF } from 'jspdf'; 
import html2canvas from 'html2canvas'; 
import '../Style/Cart.css';
import { useTranslation } from 'react-i18next';

const Cart = () => {
  const { t } = useTranslation();
  const { cartItems, removeFromCart } = useCart();

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setFont("helvetica", "normal");
    doc.setFontSize(16);
    doc.text(t('shopping_cart'), 20, 20);

    const columnWidths = [30, 30, 22, 22, 32, 32, 23];
    const headers = [
      t('type'),
      t('image'),
      t('length'),
      t('width'),
      t('thickness'),
      t('quantity'),
      t('unit')
    ];

    let y = 30;
    headers.forEach((header, index) => {
      doc.rect(10 + columnWidths.slice(0, index).reduce((a, b) => a + b, 0), y, columnWidths[index], 10);
      doc.text(header, 10 + columnWidths.slice(0, index).reduce((a, b) => a + b, 0) + 2, y + 7);
    });

    cartItems.forEach((item, index) => {
      y += 12;
      const row = [
        item.label.slice(-4),
        item.imageName,
        item.length,
        item.width,
        item.thickness,
        item.quantity,
        item.quantityType,
      ];
      row.forEach((cell, colIndex) => {
        doc.rect(10 + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0), y, columnWidths[colIndex], 10);
        doc.text(cell.toString(), 10 + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0) + 2, y + 7);
      });
    });

    doc.save('cart.pdf');
  };

  const generateImage = () => {
    html2canvas(document.querySelector(".cart-container")).then((canvas) => {
      const imageUrl = canvas.toDataURL("image/png");
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = 'cart.png';
      link.click();
    });
  };

  const sendViaWhatsApp = () => {
    const phoneNumber = "972598995512";
    let message = "🛒 " + t('my_cart') + ":\n\n";

    cartItems.forEach((item, index) => {
      message += `🧱 ${t('item')} ${index + 1}:\n`;
      message += `🔹 ${t('stone_name')}: ${item.label}\n`;
      message += `🔹 ${t('type')}: ${item.imageName}\n`;
      message += `📏 ${t('length')}: ${item.length} cm\n`;
      message += `📐 ${t('width')}: ${item.width} cm\n`;
      message += `📦 ${t('thickness')}: ${item.thickness} cm\n`;
      message += `🔢 ${t('quantity')}: ${item.quantity} ${item.quantityType}\n\n`;
    });

    message += "📤 " + t('sent_from_app');
    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="cart-container">
      <h2>🛒 {t('cartTitle')}</h2>
      {cartItems.length === 0 ? (
        <p>{t('cart_empty')}</p>
      ) : (
        <>
          <div className="cart-table">
            <div className="cart-table-header">
              <div>{t('image')}</div>
              <div>{t('stone_name')}</div>
              <div>{t('type')}</div>
              <div>{t('length')}</div>
              <div>{t('width')}</div>
              <div>{t('thickness')}</div>
              <div>{t('quantity')}</div>
              <div>{t('unit')}</div>
              <div>{t('action')}</div>
            </div>
            {cartItems.map((item, index) => (
              <div className="cart-table-row" key={index}>
                <div>
                  <img
                    src={item.selectedImage?.src || item.src2}
                    alt={item.selectedImage?.name || item.label}
                    className="cart-image"
                  />
                </div>
                <div>{item.label}</div>
                <div>{item.imageName}</div>
                <div>{item.length}</div>
                <div>{item.width}</div>
                <div>{item.thickness}</div>
                <div>{item.quantity}</div>
                <div>{item.quantityType}</div>
                <div>
                  <button onClick={() => removeFromCart(index)}>🗑️ {t('remove')}</button>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-grid">
            {cartItems.map((item, index) => (
              <div className="cart-card" key={index}>
                <img
                  src={item.selectedImage?.src || item.src2}
                  alt={item.selectedImage?.name || item.label}
                  className="cart-image"
                />
                <div className="cart-details">
                  <h3>{item.label}</h3>
                  <p><strong>{t('type')}:</strong> {item.imageName}</p>
                  <p>{t('length')}: {item.length}</p>
                  <p>{t('width')}: {item.width}</p>
                  <p>{t('thickness')}: {item.thickness}</p>
                  <p>{t('quantity')}: {item.quantity}</p>
                  <p>{t('unit')}: {item.quantityType}</p>
                  <button onClick={() => removeFromCart(index)}>🗑️ {t('remove')}</button>
                </div>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <button className='click' onClick={generatePDF}>📄 {t('downloadPDF')}</button>
            <button className='click' onClick={generateImage}>🖼️ {t('downloadImage')}</button>
            <button className='click' onClick={sendViaWhatsApp}>📱 {t('sendWhatsApp')}</button>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;
